import React from "react";
import "./App.scss";
import Main from "./containers/Main";
import "@fortawesome/fontawesome-free/css/all.min.css";

function App() {
  return (
    <div>
      <Main />
    </div>
  );
}

export default App;
